import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared.module';
import {NgxPermissionsModule} from 'ngx-permissions';
import {RouterModule} from '@angular/router';
import {PipesModule} from '../../views/pipes/pipes.module';
import {MDashboardComponent} from './views/dashboard/m-dashboard.component';
import {routes} from './mobile.routing';
import {MOesWorkspaceSelectorComponent} from './components/oes-workspace-selector/m-oes-workspace-selector.component';
import {MatDialogModule} from '@angular/material';
import {MMasterDataComponent} from './views/master-data/m-master-data.component';
import {MTransactionsComponent} from './views/transactions/m-transactions.component';
import {ContextMenuModule, PaginatorModule} from 'primeng/primeng';
import {MPaginationControlComponent} from './components/pagination-control/m-pagination-control.component';
import {MFilterModalComponent} from './components/filter-modal/m-filter-modal.component';
import {MAppliedFiltersComponent} from './components/applied-filters/m-applied-filters.component';
import {MMasterDataViewComponent} from './views/master-data/master-data-view/m-master-data-view.component';
import {LoadingModule} from 'ngx-loading';
import {MScannedDataComponent} from './views/scanned-data/m-scanned-data.component';
import {MScannedDataViewComponent} from './views/scanned-data/scanned-data-view/m-scanned-data-view.component';
import {MTransactionViewComponent} from './views/transactions/transaction-view/m-transaction-view.component';
import {MQuickOrderComponent} from './views/quick-order/m-quick-order.component';
import {MPartSelectionModalComponent} from './components/part-selection-modal/m-part-selection-modal.component';
import {MQuickOrderLineEditComponent} from './views/quick-order/quick-order-line-edit/m-quick-order-line-edit.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        FormsModule,
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        PipesModule,
        MatDialogModule,
        PaginatorModule,
        ContextMenuModule,
        LoadingModule
    ],
    providers: [],
    declarations: [
        MDashboardComponent,
        MMasterDataComponent,
        MMasterDataViewComponent,
        MTransactionsComponent,
        MTransactionViewComponent,
        MScannedDataComponent,
        MScannedDataViewComponent,
        MQuickOrderComponent,
        MQuickOrderLineEditComponent,
        MOesWorkspaceSelectorComponent,
        MPaginationControlComponent,
        MFilterModalComponent,
        MAppliedFiltersComponent,
        MPartSelectionModalComponent
    ],
    entryComponents: [
        MOesWorkspaceSelectorComponent,
        MFilterModalComponent,
        MPartSelectionModalComponent,
        MQuickOrderLineEditComponent
    ],
    exports: []
})
export class MobileModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/mobile.module.ts